import Action, { GetContext, } from './Action';
const MessageTo = Symbol('to');
const MessageBody = Symbol('body');
export default class Message extends Action {
    constructor(to, body) {
        if ((typeof to !== 'string' || !to.length)
            && (!(Array.isArray(to)
                && to.every((s) => (typeof s === 'string' && Boolean(s.length)))))) {
            throw new TypeError('Message constructor expects a non-empty string or an array of non-empty strings as the first argument');
        }
        if (typeof body !== 'string' || !body.length) {
            throw new TypeError('Message constructor expects a non-empty string as the second argument');
        }
        super();
        this[MessageTo] = Array.isArray(to) ? to : [to];
        this[MessageBody] = body;
        this[GetContext] =
            () => ({ to: this.to, body });
    }
    get to() {
        return this[MessageTo];
    }
    get body() {
        return this[MessageBody];
    }
    getContext() {
        return {
            body: this[MessageBody],
            to: this.to,
        };
    }
}
